import { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';

import messages from './messages';
import {
	ButtonWrapper,
	DownArrow,
	NextArrow,
	NextButton,
	PrevArrow,
	PrevButton,
	Select,
	SelectWrapper,
	Wrapper,
} from './styles';
import { ContentNavProps } from './types';

const ContentNav = ({ currentDay, totalDays, onPageChange }: ContentNavProps) => {
	const { formatMessage } = useIntl();

	// creates an array of numbers starting from 1 eg [1, ..., 30]
	const selectOptions = [...Array(totalDays).keys()].map(index => index + 1);

	const onPageSelect = (e: ChangeEvent<HTMLSelectElement>) => {
		onPageChange(+e.target.value);
	};

	const onPrev = () => {
		if (currentDay >= 1) {
			onPageChange(currentDay - 1);
		}
	};

	const onNext = () => {
		if (currentDay < totalDays) {
			onPageChange(currentDay + 1);
		}
	};

	return (
		<Wrapper>
			<SelectWrapper>
				<Select name="days" id="days" onChange={onPageSelect} value={currentDay}>
					{selectOptions.map(day => (
						<option value={day} key={day}>
							{formatMessage(messages.day)} {day}
						</option>
					))}
				</Select>
				<DownArrow />
			</SelectWrapper>
			<ButtonWrapper>
				{currentDay > 1 && (
					<PrevButton onClick={onPrev}>
						<PrevArrow />
						{formatMessage(messages.previous)}
					</PrevButton>
				)}
				{currentDay < totalDays && (
					<NextButton onClick={onNext}>
						{formatMessage(messages.next)}
						<NextArrow />
					</NextButton>
				)}
			</ButtonWrapper>
		</Wrapper>
	);
};

export default ContentNav;
